import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Chart } from "react-google-charts";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mobile: { minWidth: "1200px", height: "450px" },
    desktop: { minWidth: "100%" },
  })
);

export default function ChartPie(propsPie: chartPieProps) {
  const styleGraphics = useStyles();

  const options = {
    title: propsPie.title,
    //pieSliceText: "label",
    is3D: true,
    sliceVisibilityThreshold: 0.0000001,
    slices: {
      1: { offset: 0.2 },
      2: { offset: 0.3 },
      //3: { offset: 0.4},
      4: { offset: 0.3 },
      5: { offset: 0.2 },
      6: { offset: 0.3 },
      //7: { offset: 0.4 },
      8: { offset: 0.3 },
      9: { offset: 0.2 },
      10: { offset: 0.3 },
      //11: { offset: 0.4 },
      12: { offset: 0.3 },
      13: { offset: 0.2 },
      14: { offset: 0.3 },
      //15: { offset: 0.4},
      16: { offset: 0.3 },
      17: { offset: 0.2 },
      18: { offset: 0.3 },
      //19: { offset: 0.4 },
      20: { offset: 0.3 },
      21: { offset: 0.2 },
      22: { offset: 0.3 },
      //23: { offset: 0.4},
      24: { offset: 0.3 },
      25: { offset: 0.2 },
      26: { offset: 0.3 },
      //27: { offset: 0.4 },
      28: { offset: 0.3 },
      29: { offset: 0.2 },
      30: { offset: 0.3 },
      //31: { offset: 0.4},
      32: { offset: 0.3 },
      33: { offset: 0.2 },
      34: { offset: 0.3 },
      //35: { offset: 0.4 },
      37: { offset: 0.3 },
      38: { offset: 0.2 },
      39: { offset: 0.3 },
      //40: { offset: 0.4 },
      41: { offset: 0.3 },
      42: { offset: 0.2 },
      43: { offset: 0.3 },
      //44: { offset: 0.4},
      45: { offset: 0.3 },
      46: { offset: 0.2 },
      47: { offset: 0.3 },
      //48: { offset: 0.4 },
      49: { offset: 0.3 },
      50: { offset: 0.2 },
      51: { offset: 0.3 },
      //52: { offset: 0.4},
      53: { offset: 0.3 },
      54: { offset: 0.2 },
      55: { offset: 0.3 },
      //56: { offset: 0.4 },
      57: { offset: 0.3 },
      58: { offset: 0.2 },
      59: { offset: 0.3 },
      //60: { offset: 0.4},
      61: { offset: 0.3 },
      62: { offset: 0.2 },
      63: { offset: 0.3 },
      //64: { offset: 0.4 },
      65: { offset: 0.3 },
      66: { offset: 0.2 },
      67: { offset: 0.3 },
      //68: { offset: 0.4 },
      69: { offset: 0.3 },
      70: { offset: 0.2 },
      71: { offset: 0.3 },
      //72: { offset: 0.4},
      73: { offset: 0.3 },
      74: { offset: 0.2 },
      75: { offset: 0.3 },
      //76: { offset: 0.4 },
      77: { offset: 0.3 },
      78: { offset: 0.2 },
      79: { offset: 0.3 },
      //80: { offset: 0.4},
      81: { offset: 0.3 },
      82: { offset: 0.2 },
      83: { offset: 0.3 },
      //84: { offset: 0.4 },
      85: { offset: 0.3 },
      87: { offset: 0.2 },
      88: { offset: 0.3 },
      //89: { offset: 0.4},
      90: { offset: 0.3 },
      91: { offset: 0.2 },
      92: { offset: 0.3 },
      //93: { offset: 0.4 },
      94: { offset: 0.3 },
      95: { offset: 0.2 },
      96: { offset: 0.3 },
      //97: { offset: 0.4 },
      98: { offset: 0.3 },
      99: { offset: 0.2 },
      100: { offset: 0.3 },
      101: { offset: 0.2 },
      102: { offset: 0.3 },
      //3: { offset: 0.4},
      104: { offset: 0.3 },
      105: { offset: 0.2 },
      106: { offset: 0.3 },
      //7: { offset: 0.4 },
      108: { offset: 0.3 },
      109: { offset: 0.2 },
      110: { offset: 0.3 },
      //11: { offset: 0.4 },
      112: { offset: 0.3 },
      113: { offset: 0.2 },
      114: { offset: 0.3 },
      //15: { offset: 0.4},
      116: { offset: 0.3 },
      117: { offset: 0.2 },
      118: { offset: 0.3 },
      //19: { offset: 0.4 },
      120: { offset: 0.3 },
      121: { offset: 0.2 },
      122: { offset: 0.3 },
      //23: { offset: 0.4},
      124: { offset: 0.3 },
      125: { offset: 0.2 },
      126: { offset: 0.3 },
      //27: { offset: 0.4 },
      128: { offset: 0.3 },
      129: { offset: 0.2 },
      130: { offset: 0.3 },
      //31: { offset: 0.4},
      132: { offset: 0.3 },
      133: { offset: 0.2 },
      134: { offset: 0.3 },
      //35: { offset: 0.4 },
      137: { offset: 0.3 },
      138: { offset: 0.2 },
      139: { offset: 0.3 },
      //40: { offset: 0.4 },
      141: { offset: 0.3 },
      142: { offset: 0.2 },
      143: { offset: 0.3 },
      //44: { offset: 0.4},
      145: { offset: 0.3 },
      146: { offset: 0.2 },
      147: { offset: 0.3 },
      //48: { offset: 0.4 },
      149: { offset: 0.3 },
      150: { offset: 0.2 },
      151: { offset: 0.3 },
      //52: { offset: 0.4},
      153: { offset: 0.3 },
      154: { offset: 0.2 },
      155: { offset: 0.3 },
      //56: { offset: 0.4 },
      157: { offset: 0.3 },
      158: { offset: 0.2 },
      159: { offset: 0.3 },
      //60: { offset: 0.4},
      161: { offset: 0.3 },
      162: { offset: 0.2 },
      163: { offset: 0.3 },
      //64: { offset: 0.4 },
      165: { offset: 0.3 },
      166: { offset: 0.2 },
      167: { offset: 0.3 },
      //68: { offset: 0.4 },
      169: { offset: 0.3 },
      170: { offset: 0.2 },
      171: { offset: 0.3 },
      //72: { offset: 0.4},
      173: { offset: 0.3 },
      174: { offset: 0.2 },
      175: { offset: 0.3 },
      //76: { offset: 0.4 },
      177: { offset: 0.3 },
      178: { offset: 0.2 },
      179: { offset: 0.3 },
      //80: { offset: 0.4},
      181: { offset: 0.3 },
      182: { offset: 0.2 },
      183: { offset: 0.3 },
      //84: { offset: 0.4 },
      185: { offset: 0.3 },
      187: { offset: 0.2 },
      188: { offset: 0.3 },
      //89: { offset: 0.4},
      190: { offset: 0.3 },
      191: { offset: 0.2 },
      192: { offset: 0.3 },
      //93: { offset: 0.4 },
      194: { offset: 0.3 },
      195: { offset: 0.2 },
      196: { offset: 0.3 },
      //97: { offset: 0.4 },
      198: { offset: 0.3 },
      199: { offset: 0.2 },
      200: { offset: 0.3 },
      201: { offset: 0.2 },
      202: { offset: 0.3 },
      //3: { offset: 0.4},
      204: { offset: 0.3 },
      205: { offset: 0.2 },
      206: { offset: 0.3 },
      //7: { offset: 0.4 },
      208: { offset: 0.3 },
      209: { offset: 0.2 },
      210: { offset: 0.3 },
      //11: { offset: 0.4 },
      212: { offset: 0.3 },
      213: { offset: 0.2 },
      214: { offset: 0.3 },
      //15: { offset: 0.4},
      216: { offset: 0.3 },
      217: { offset: 0.2 },
      218: { offset: 0.3 },
      //19: { offset: 0.4 },
      220: { offset: 0.3 },
      221: { offset: 0.2 },
      222: { offset: 0.3 },
      //23: { offset: 0.4},
      224: { offset: 0.3 },
      225: { offset: 0.2 },
      226: { offset: 0.3 },
      //27: { offset: 0.4 },
      228: { offset: 0.3 },
      229: { offset: 0.2 },
      230: { offset: 0.3 },
      //31: { offset: 0.4},
      232: { offset: 0.3 },
      233: { offset: 0.2 },
      234: { offset: 0.3 },
      //35: { offset: 0.4 },
      237: { offset: 0.3 },
      238: { offset: 0.2 },
      239: { offset: 0.3 },
      //40: { offset: 0.4 },
      241: { offset: 0.3 },
      242: { offset: 0.2 },
      243: { offset: 0.3 },
      //44: { offset: 0.4},
      245: { offset: 0.3 },
      246: { offset: 0.2 },
      247: { offset: 0.3 },
      //48: { offset: 0.4 },
      249: { offset: 0.3 },
      250: { offset: 0.2 },
      251: { offset: 0.3 },
      //52: { offset: 0.4},
      253: { offset: 0.3 },
      254: { offset: 0.2 },
      255: { offset: 0.3 },
      //56: { offset: 0.4 },
      257: { offset: 0.3 },
      258: { offset: 0.2 },
      259: { offset: 0.3 },
      //60: { offset: 0.4},
      261: { offset: 0.3 },
      262: { offset: 0.2 },
      263: { offset: 0.3 },
      //64: { offset: 0.4 },
      265: { offset: 0.3 },
      266: { offset: 0.2 },
      267: { offset: 0.3 },
      //68: { offset: 0.4 },
      269: { offset: 0.3 },
      270: { offset: 0.2 },
      271: { offset: 0.3 },
      //72: { offset: 0.4},
      273: { offset: 0.3 },
      274: { offset: 0.2 },
      275: { offset: 0.3 },
      //76: { offset: 0.4 },
      277: { offset: 0.3 },
      278: { offset: 0.2 },
      279: { offset: 0.3 },
      //80: { offset: 0.4},
      281: { offset: 0.3 },
      282: { offset: 0.2 },
      283: { offset: 0.3 },
      //84: { offset: 0.4 },
      285: { offset: 0.3 },
      287: { offset: 0.2 },
      288: { offset: 0.3 },
      //89: { offset: 0.4},
      290: { offset: 0.3 },
      291: { offset: 0.2 },
      292: { offset: 0.3 },
      //93: { offset: 0.4 },
      294: { offset: 0.3 },
      295: { offset: 0.2 },
      296: { offset: 0.3 },
      //97: { offset: 0.4 },
      298: { offset: 0.3 },
      299: { offset: 0.2 },
      300: { offset: 0.3 },
      301: { offset: 0.2 },
      302: { offset: 0.3 },
      //3: { offset: 0.4},
      304: { offset: 0.3 },
      305: { offset: 0.2 },
      306: { offset: 0.3 },
      //7: { offset: 0.4 },
      308: { offset: 0.3 },
      309: { offset: 0.2 },
      310: { offset: 0.3 },
      //11: { offset: 0.4 },
      312: { offset: 0.3 },
      313: { offset: 0.2 },
      314: { offset: 0.3 },
      //15: { offset: 0.4},
      316: { offset: 0.3 },
      317: { offset: 0.2 },
      318: { offset: 0.3 },
      //19: { offset: 0.4 },
      320: { offset: 0.3 },
      321: { offset: 0.2 },
      322: { offset: 0.3 },
      //23: { offset: 0.4},
      324: { offset: 0.3 },
      325: { offset: 0.2 },
      326: { offset: 0.3 },
      //27: { offset: 0.4 },
      328: { offset: 0.3 },
      329: { offset: 0.2 },
      330: { offset: 0.3 },
      //31: { offset: 0.4},
      332: { offset: 0.3 },
      333: { offset: 0.2 },
      334: { offset: 0.3 },
      //35: { offset: 0.4 },
      337: { offset: 0.3 },
      338: { offset: 0.2 },
      339: { offset: 0.3 },
      //40: { offset: 0.4 },
      341: { offset: 0.3 },
      342: { offset: 0.2 },
      343: { offset: 0.3 },
      //44: { offset: 0.4},
      345: { offset: 0.3 },
      346: { offset: 0.2 },
      347: { offset: 0.3 },
      //48: { offset: 0.4 },
      349: { offset: 0.3 },
      350: { offset: 0.2 },
      351: { offset: 0.3 },
      //52: { offset: 0.4},
      353: { offset: 0.3 },
      354: { offset: 0.2 },
      355: { offset: 0.3 },
      //56: { offset: 0.4 },
      357: { offset: 0.3 },
      358: { offset: 0.2 },
      359: { offset: 0.3 },
      //60: { offset: 0.4},
      361: { offset: 0.3 },
      362: { offset: 0.2 },
      363: { offset: 0.3 },
      //64: { offset: 0.4 },
      365: { offset: 0.3 },
      366: { offset: 0.2 },
      367: { offset: 0.3 },
      //68: { offset: 0.4 },
      369: { offset: 0.3 },
      370: { offset: 0.2 },
      371: { offset: 0.3 },
      //72: { offset: 0.4},
      373: { offset: 0.3 },
      374: { offset: 0.2 },
      375: { offset: 0.3 },
      //76: { offset: 0.4 },
      377: { offset: 0.3 },
      378: { offset: 0.2 },
      379: { offset: 0.3 },
      //80: { offset: 0.4},
      381: { offset: 0.3 },
      382: { offset: 0.2 },
      383: { offset: 0.3 },
      //84: { offset: 0.4 },
      385: { offset: 0.3 },
      387: { offset: 0.2 },
      388: { offset: 0.3 },
      //89: { offset: 0.4},
      390: { offset: 0.3 },
      391: { offset: 0.2 },
      392: { offset: 0.3 },
      //93: { offset: 0.4 },
      394: { offset: 0.3 },
      395: { offset: 0.2 },
      396: { offset: 0.3 },
      //97: { offset: 0.4 },
      398: { offset: 0.3 },
      399: { offset: 0.2 },
      400: { offset: 0.3 },
      401: { offset: 0.2 },
      402: { offset: 0.3 },
      //3: { offset: 0.4},
      404: { offset: 0.3 },
      405: { offset: 0.2 },
      406: { offset: 0.3 },
      //7: { offset: 0.4 },
      408: { offset: 0.3 },
      409: { offset: 0.2 },
      410: { offset: 0.3 },
      //11: { offset: 0.4 },
      412: { offset: 0.3 },
      413: { offset: 0.2 },
      414: { offset: 0.3 },
      //15: { offset: 0.4},
      416: { offset: 0.3 },
      417: { offset: 0.2 },
      418: { offset: 0.3 },
      //19: { offset: 0.4 },
      420: { offset: 0.3 },
      421: { offset: 0.2 },
      422: { offset: 0.3 },
      //23: { offset: 0.4},
      424: { offset: 0.3 },
      425: { offset: 0.2 },
      426: { offset: 0.3 },
      //27: { offset: 0.4 },
      428: { offset: 0.3 },
      429: { offset: 0.2 },
      430: { offset: 0.3 },
      //31: { offset: 0.4},
      432: { offset: 0.3 },
      433: { offset: 0.2 },
      434: { offset: 0.3 },
      //35: { offset: 0.4 },
      437: { offset: 0.3 },
      438: { offset: 0.2 },
      439: { offset: 0.3 },
      //40: { offset: 0.4 },
      441: { offset: 0.3 },
      442: { offset: 0.2 },
      443: { offset: 0.3 },
      //44: { offset: 0.4},
      445: { offset: 0.3 },
      446: { offset: 0.2 },
      447: { offset: 0.3 },
      //48: { offset: 0.4 },
      449: { offset: 0.3 },
      450: { offset: 0.2 },
      451: { offset: 0.3 },
      //52: { offset: 0.4},
      453: { offset: 0.3 },
      454: { offset: 0.2 },
      455: { offset: 0.3 },
      //56: { offset: 0.4 },
      457: { offset: 0.3 },
      458: { offset: 0.2 },
      459: { offset: 0.3 },
      //60: { offset: 0.4},
      461: { offset: 0.3 },
      462: { offset: 0.2 },
      463: { offset: 0.3 },
      //64: { offset: 0.4 },
      465: { offset: 0.3 },
      466: { offset: 0.2 },
      467: { offset: 0.3 },
      //68: { offset: 0.4 },
      469: { offset: 0.3 },
      470: { offset: 0.2 },
      471: { offset: 0.3 },
      //72: { offset: 0.4},
      473: { offset: 0.3 },
      474: { offset: 0.2 },
      475: { offset: 0.3 },
      //76: { offset: 0.4 },
      477: { offset: 0.3 },
      478: { offset: 0.2 },
      479: { offset: 0.3 },
      //80: { offset: 0.4},
      481: { offset: 0.3 },
      482: { offset: 0.2 },
      483: { offset: 0.3 },
      //84: { offset: 0.4 },
      485: { offset: 0.3 },
      487: { offset: 0.2 },
      488: { offset: 0.3 },
      //89: { offset: 0.4},
      490: { offset: 0.3 },
      491: { offset: 0.2 },
      492: { offset: 0.3 },
      //93: { offset: 0.4 },
      494: { offset: 0.3 },
      495: { offset: 0.2 },
      496: { offset: 0.3 },
      //97: { offset: 0.4 },
      498: { offset: 0.3 },
      499: { offset: 0.2 },
      500: { offset: 0.3 },
      501: { offset: 0.2 },
      502: { offset: 0.3 },
      //3: { offset: 0.4},
      504: { offset: 0.3 },
      505: { offset: 0.2 },
      506: { offset: 0.3 },
      //7: { offset: 0.4 },
      508: { offset: 0.3 },
      509: { offset: 0.2 },
      510: { offset: 0.3 },
      //11: { offset: 0.4 },
      512: { offset: 0.3 },
      513: { offset: 0.2 },
      514: { offset: 0.3 },
      //15: { offset: 0.4},
      516: { offset: 0.3 },
      517: { offset: 0.2 },
      518: { offset: 0.3 },
      //19: { offset: 0.4 },
      520: { offset: 0.3 },
      521: { offset: 0.2 },
      522: { offset: 0.3 },
      //23: { offset: 0.4},
      524: { offset: 0.3 },
      525: { offset: 0.2 },
      526: { offset: 0.3 },
      //27: { offset: 0.4 },
      528: { offset: 0.3 },
      529: { offset: 0.2 },
      530: { offset: 0.3 },
      //31: { offset: 0.4},
      532: { offset: 0.3 },
      533: { offset: 0.2 },
      534: { offset: 0.3 },
      //35: { offset: 0.4 },
      537: { offset: 0.3 },
      538: { offset: 0.2 },
      539: { offset: 0.3 },
      //40: { offset: 0.4 },
      541: { offset: 0.3 },
      542: { offset: 0.2 },
      543: { offset: 0.3 },
      //44: { offset: 0.4},
      545: { offset: 0.3 },
      546: { offset: 0.2 },
      547: { offset: 0.3 },
      //48: { offset: 0.4 },
      549: { offset: 0.3 },
      550: { offset: 0.2 },
      551: { offset: 0.3 },
      //52: { offset: 0.4},
      553: { offset: 0.3 },
      554: { offset: 0.2 },
      555: { offset: 0.3 },
      //56: { offset: 0.4 },
      557: { offset: 0.3 },
      558: { offset: 0.2 },
      559: { offset: 0.3 },
      //60: { offset: 0.4},
      561: { offset: 0.3 },
      562: { offset: 0.2 },
      563: { offset: 0.3 },
      //64: { offset: 0.4 },
      565: { offset: 0.3 },
      566: { offset: 0.2 },
      567: { offset: 0.3 },
      //68: { offset: 0.4 },
      569: { offset: 0.3 },
      570: { offset: 0.2 },
      571: { offset: 0.3 },
      //72: { offset: 0.4},
      573: { offset: 0.3 },
      574: { offset: 0.2 },
      575: { offset: 0.3 },
      //76: { offset: 0.4 },
      577: { offset: 0.3 },
      578: { offset: 0.2 },
      579: { offset: 0.3 },
      //80: { offset: 0.4},
      581: { offset: 0.3 },
      582: { offset: 0.2 },
      583: { offset: 0.3 },
      //84: { offset: 0.4 },
      585: { offset: 0.3 },
      587: { offset: 0.2 },
      588: { offset: 0.3 },
      //89: { offset: 0.4},
      590: { offset: 0.3 },
      591: { offset: 0.2 },
      592: { offset: 0.3 },
      //93: { offset: 0.4 },
      594: { offset: 0.3 },
      595: { offset: 0.2 },
      596: { offset: 0.3 },
      //97: { offset: 0.4 },
      598: { offset: 0.3 },
      599: { offset: 0.2 },
      600: { offset: 0.3 },
    },
  };

  return (
    <div
      className={
        window.screen.width < 1000
          ? styleGraphics.mobile
          : styleGraphics.desktop
      }
    >
      <Chart
        chartType="PieChart"
        data={propsPie.data}
        options={options}
        width={"100%"}
        height={"500px"}
        loader={
          <img
            height="150"
            width="150"
            src="https://mir-s3-cdn-cf.behance.net/project_modules/disp/35771931234507.564a1d2403b3a.gif"
            alt=""
          ></img>
        }
        chartEvents={[
          {
            eventName: "ready",
            callback: ({ chartWrapper, props }) => {
              const chart = chartWrapper.getChart().getImageURI();
              propsPie.getImage(chart);
            },
          },
        ]}
      />
    </div>
  );
}

interface chartPieProps {
  data: any[];
  title: string;
  getImage(img: any): void;
}
